import { apiFetch } from './client.js';

export interface AccountActionResult {
  ok: boolean;
  state: string;
}

export interface CardActionResult {
  cardId: string;
  state: string;
  timestamp: string;
}


export const customerActionsApi = {
  freezeAccount: (customerId: string, accountId: string, reason: string): Promise<AccountActionResult> =>
    apiFetch<AccountActionResult>(
      `/admin/customers/${customerId}/accounts/${accountId}/freeze`,
      { method: 'POST', body: { reason } },
    ),

  suspendAccount: (customerId: string, accountId: string, reason: string): Promise<AccountActionResult> =>
    apiFetch<AccountActionResult>(
      `/admin/customers/${customerId}/accounts/${accountId}/suspend`,
      { method: 'POST', body: { reason } },
    ),

  closeAccount: (customerId: string, accountId: string, reason: string): Promise<AccountActionResult> =>
    apiFetch<AccountActionResult>(
      `/admin/customers/${customerId}/accounts/${accountId}/close`,
      { method: 'POST', body: { reason } },
    ),

  unfreezeAccount: (customerId: string, accountId: string, reason: string): Promise<AccountActionResult> =>
    apiFetch<AccountActionResult>(
      `/admin/customers/${customerId}/accounts/${accountId}/unfreeze`,
      { method: 'POST', body: { reason } },
    ),

  freezeCard: (customerId: string, cardId: string, reason: string): Promise<CardActionResult> =>
    apiFetch<CardActionResult>(
      `/admin/customers/${customerId}/cards/${cardId}/freeze`,
      { method: 'POST', body: { reason } },
    ),

  cancelCard: (customerId: string, cardId: string, reason: string): Promise<CardActionResult> =>
    apiFetch<CardActionResult>(
      `/admin/customers/${customerId}/cards/${cardId}/cancel`,
      { method: 'POST', body: { reason } },
    ),

  // overrideCardLimits was removed: it posted to
  // /admin/customers/:id/cards/:cardId/limit-override, which exists only in
  // apps/backoffice-api — an app the dev stack does not start and nothing
  // proxies to. Nothing rendered it, so no button broke; leaving it would have
  // let whoever builds the card-limits UI believe the backend was there and
  // ship a spend control that silently does nothing.

};
